export default __webpack_public_path__ + "static/media/arrow-left-icon.261dd8cf.svg";